export default __webpack_public_path__ + "static/media/LogoADportal.0373d18b.png";